export default {
  Variation2: "variation2",
  Variation3: "variation3",
  VariationCa: "variationCa",
  VariationUk: "variationUk",
};
